import MultipleListsView from './MultipleListsView';

export default MultipleListsView;
